import React from "react";
import { Composition } from "remotion";
import { SutraClip, SutraClipProps } from "./compositions/SutraClip";
import { StyleTest, StyleName } from "./compositions/StyleTest";
import { PLATFORMS } from "./styles/theme";
import type { Clip } from "./lib/segment-episode";

// Demo clip for preview in Remotion Studio
const DEMO_CLIP: Clip = {
  clipId: "ys-01-clip-001",
  episodeNumber: 1,
  seriesSlug: "patanjali-yoga-sutras-2019",
  title: "What is Yoga, really?",
  cues: [
    { index: 1, startTime: 0, endTime: 5, text: "Atha Yoganushasanam — Now begins the discipline of Yoga." },
    { index: 2, startTime: 5.5, endTime: 12, text: "Yoga is not just exercise. Yoga is the skill of keeping your mind in the present moment." },
    { index: 3, startTime: 12.5, endTime: 20, text: "When the mind is free from all the impressions, when it is calm, that is Yoga." },
    { index: 4, startTime: 20.5, endTime: 28, text: "Patanjali says — Yogas Chitta Vritti Nirodha. Yoga is the cessation of the fluctuations of the mind." },
    { index: 5, startTime: 28.5, endTime: 36, text: "When the mind becomes still, you experience your true nature. That is Samadhi." },
    { index: 6, startTime: 36.5, endTime: 44, text: "The whole science of Yoga is to bring you to that experience — to know who you truly are." },
    { index: 7, startTime: 44.5, endTime: 52, text: "And Patanjali has laid this out in the most systematic, scientific way possible." },
    { index: 8, startTime: 52.5, endTime: 58, text: "So let us begin this beautiful journey together." },
  ],
  startTime: 0,
  endTime: 58,
  duration: 58,
  hookLine: "What is Yoga, really?",
  hookType: "question",
  isScriptureCard: false,
};

// 10 style names for test renders
const STYLES: StyleName[] = [
  "mandala", "breathing", "particles", "caustics", "geometry",
  "lotus", "glow", "minimal", "waves", "vortex",
];

// Total reel duration: ~60 seconds
const REEL_DURATION_FRAMES = 60 * 30;

export const Root: React.FC = () => {
  return (
    <>
      {/* === STYLE TEST COMPOSITIONS (9:16 portrait for Reels) === */}
      {STYLES.map((style) => (
        <Composition
          key={`style-${style}`}
          id={`style-${style}`}
          component={StyleTest}
          durationInFrames={REEL_DURATION_FRAMES}
          fps={30}
          width={1080}
          height={1920}
          defaultProps={{ styleName: style }}
        />
      ))}

      {/* === ORIGINAL DEMO COMPOSITIONS === */}
      <Composition
        id="demo-youtube"
        component={SutraClip}
        durationInFrames={DEMO_CLIP.duration * 30}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          clip: DEMO_CLIP,
          platform: "youtube" as const,
          format: "landscape" as const,
          language: "en" as const,
        }}
      />
      <Composition
        id="demo-reels"
        component={SutraClip}
        durationInFrames={DEMO_CLIP.duration * 30}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          clip: DEMO_CLIP,
          platform: "reels" as const,
          format: "portrait" as const,
          language: "en" as const,
        }}
      />
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
